<template>
    <div class="col-md-6 col-lg-3">
      <div class="card h-100 shadow-sm">
        <img :src="image" class="card-img-top" :alt="title">
        <div class="card-body">
          <h5 class="card-title fw-bold">{{ title }}</h5>
          <p class="card-text">{{ description }}</p>
          <a :href="link" class="btn btn-primary">Learn More</a>
        </div>
      </div>
    </div>
  </template>
  
  
  <script>
  export default {
    props: {
      title: String,
      description: String,
      image: String,
      link: String
    }
  }
  </script>

  <style>


</style>
  